module.exports = __webpack_public_path__ + "img/banner_tjx_train.9d59d190.jpg";